// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../../bundles/Form/Form.res.js";

function get(values, field) {
  switch (field) {
    case "MaxStockThreshold" :
      return values.maxStockThreshold;
    case "MinStockThreshold" :
      return values.minStockThreshold;
    case "StockOrderTriggerThreshold" :
      return values.stockOrderTriggerThreshold;
  }
}

function set(values, field, value) {
  switch (field) {
    case "MaxStockThreshold" :
      return {
        maxStockThreshold: value,
        minStockThreshold: values.minStockThreshold,
        stockOrderTriggerThreshold: values.stockOrderTriggerThreshold
      };
    case "MinStockThreshold" :
      return {
        maxStockThreshold: values.maxStockThreshold,
        minStockThreshold: value,
        stockOrderTriggerThreshold: values.stockOrderTriggerThreshold
      };
    case "StockOrderTriggerThreshold" :
      return {
        maxStockThreshold: values.maxStockThreshold,
        minStockThreshold: values.minStockThreshold,
        stockOrderTriggerThreshold: value
      };
  }
}

let Lenses_ = {
  get: get,
  set: set
};

let Lenses = {
  get: get,
  set: set
};

let include = Form.Make(Lenses);

let Core = include.Core;

let Schema = include.Schema;

let FormLegacyProvider = include.FormLegacyProvider;

let FormProvider = include.FormProvider;

let InputText = include.InputText;

let InputSuggestionComboBox = include.InputSuggestionComboBox;

let InputSelect = include.InputSelect;

let InputToggleButtonGroup = include.InputToggleButtonGroup;

let InputCountrySelect = include.InputCountrySelect;

let InputTextArea = include.InputTextArea;

let InputPassword = include.InputPassword;

let InputNumber = include.InputNumber;

let InputOptionalNumber = include.InputOptionalNumber;

let InputRadioGroup = include.InputRadioGroup;

let InputRadioCardGroup = include.InputRadioCardGroup;

let InputPhone = include.InputPhone;

let InputCheckbox = include.InputCheckbox;

let InputToggleSwitch = include.InputToggleSwitch;

let InputDate = include.InputDate;

let InputOptionalDate = include.InputOptionalDate;

let InputOptionalDateFastNav = include.InputOptionalDateFastNav;

let InputDateRange = include.InputDateRange;

let CancelButton = include.CancelButton;

let SubmitButton = include.SubmitButton;

let ControlEnterKey = include.ControlEnterKey;

let AutoSave = include.AutoSave;

let useFormPropState = include.useFormPropState;

let useField = include.useField;

let useFormState = include.useFormState;

let useFormDispatch = include.useFormDispatch;

let validate = include.validate;

let isValidField = include.isValidField;

export {
  Lenses_,
  Lenses,
  Core,
  Schema,
  FormLegacyProvider,
  FormProvider,
  InputText,
  InputSuggestionComboBox,
  InputSelect,
  InputToggleButtonGroup,
  InputCountrySelect,
  InputTextArea,
  InputPassword,
  InputNumber,
  InputOptionalNumber,
  InputRadioGroup,
  InputRadioCardGroup,
  InputPhone,
  InputCheckbox,
  InputToggleSwitch,
  InputDate,
  InputOptionalDate,
  InputOptionalDateFastNav,
  InputDateRange,
  CancelButton,
  SubmitButton,
  ControlEnterKey,
  AutoSave,
  useFormPropState,
  useField,
  useFormState,
  useFormDispatch,
  validate,
  isValidField,
}
/* include Not a pure module */
